import { render, staticRenderFns } from "./PresentLevels.vue?vue&type=template&id=32c4ea84&scoped=true"
import script from "./PresentLevels.vue?vue&type=script&lang=js"
export * from "./PresentLevels.vue?vue&type=script&lang=js"
import style0 from "./PresentLevels.vue?vue&type=style&index=0&id=32c4ea84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c4ea84",
  null
  
)

export default component.exports